import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';
import { UserRole } from '../types';

interface AdminProtectedRouteProps {
  children: ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/administration-club" replace />;
  }

  // Verify user has CLUB_ADMIN role
  if (user?.role !== UserRole.CLUB_ADMIN) {
    // Redirect to main app if user is not a club admin
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
